import api from '../socket';

export const checkLastRoute = last_state => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'SaveLastState',
        options: {
            last_state,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/App/requests/check_last_route_request.js